import { render, staticRenderFns } from "./abnormalDocument.vue?vue&type=template&id=63a62d59&scoped=true"
import script from "./abnormalDocument.vue?vue&type=script&lang=js"
export * from "./abnormalDocument.vue?vue&type=script&lang=js"
import style0 from "./abnormalDocument.vue?vue&type=style&index=0&id=63a62d59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a62d59",
  null
  
)

export default component.exports